/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Newsletter_Error_TitleInputs */

const es_footer_newsletter_error_title = /** @type {(inputs: Footer_Newsletter_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha podido suscribir`)
};

const gl_footer_newsletter_error_title = /** @type {(inputs: Footer_Newsletter_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non se puido subscribir`)
};

const en_footer_newsletter_error_title = /** @type {(inputs: Footer_Newsletter_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not subscribe`)
};

/**
* | output |
* | --- |
* | "Could not subscribe" |
*
* @param {Footer_Newsletter_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_newsletter_error_title = /** @type {((inputs?: Footer_Newsletter_Error_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Newsletter_Error_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_newsletter_error_title(inputs)
	if (locale === "en") return en_footer_newsletter_error_title(inputs)
	return es_footer_newsletter_error_title(inputs)
});